import { InfoIcon, Link, Text } from '@buffer-mono/popcorn'

import styles from './LinkedInVerifiedSkills.module.css'

type InfoBarProps = {
  className?: string
}

const InfoBar = ({ className }: InfoBarProps): React.JSX.Element => {
  return (
    <Text
      color="subtle"
      icon={<InfoIcon color="subtle" />}
      className={className ?? styles.infoBar}
      data-testid="linkedin-verified-skills-info-bar"
    >
      <strong>This feature is for LinkedIn profiles.</strong>{' '}
      <Link href="/settings/channels">Connect a LinkedIn profile</Link> to start
      showcasing your capabilities.
    </Text>
  )
}

export { InfoBar }
